import { userStore } from 'features/auth';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { TokenStorage } from 'shared/lib/token-storage';

export const PublicRoute: React.FC = observer(() => {
  const isAuthenticated = TokenStorage.hasTokens()
  const location = useLocation();
  
  if (isAuthenticated) {
    // Check if there's a return URL from the attempted private route access
    const from = location.state?.from?.pathname || '/profile';
    return <Navigate to={from} replace />;
  }
  
  return <Outlet />;
});